import { render } from "./view-stock-adjustment.vue?vue&type=template&id=68f5a7ec&scoped=true"
import script from "./view-stock-adjustment.vue?vue&type=script&lang=js"
export * from "./view-stock-adjustment.vue?vue&type=script&lang=js"

import "./view-stock-adjustment.vue?vue&type=style&index=0&id=68f5a7ec&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f5a7ec"]])

export default __exports__